import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { selectThemeMode, selectSidebarStyle } from "state/application/applicationSlice";
import logoV1Color from "assets/images/logo/Recreation_Logotipo vetorizado_V1_COLOR.svg";
import logoV1Mono from "assets/images/Recreation_Logotipo vetorizado_V1_MONO WHT.svg";
import logoV2Color from "assets/images/logo/Recreation_Logotipo vetorizado_V2_COLOR.svg";
import logoV2Mono from "assets/images/Recreation_Logotipo vetorizado_V2_MONO WHT.svg";

const LOGOS = {
  v1: { color: logoV1Color, mono: logoV1Mono },
  v2: { color: logoV2Color, mono: logoV2Mono },
};

/* `v1` is the auth/marketing lockup (login page); `v2` is the compact lockup
   used on every screen after login (sidebar, communities header). */
export default function BrandLogo({ variant, height, forceWhite, style }) {
  const themeMode = useSelector(selectThemeMode);
  const sidebarStyle = useSelector(selectSidebarStyle);
  const useWhite = forceWhite ?? (themeMode === "dark" || sidebarStyle === "branded");
  const logos = LOGOS[variant] || LOGOS.v2;
  return (
    <img
      src={useWhite ? logos.mono : logos.color}
      alt="RECreation"
      style={{ height, width: "auto", display: "block", ...style }}
    />
  );
}

BrandLogo.propTypes = {
  variant: PropTypes.oneOf(["v1", "v2"]),
  height: PropTypes.number,
  forceWhite: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

BrandLogo.defaultProps = {
  variant: "v2",
  height: 30,
  forceWhite: undefined,
  style: undefined,
};
